module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "-section-colTerminal col-xs-8 col-padding"
  }, [_c('div', {
    staticClass: "terminal-block",
    attrs: {
      "id": "terminal"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-welcome"
  }, [_vm._v("\n                 " + _vm._s(_vm._f("moment")(new Date(), 'MMMM Do YYYY, kk:mm')) + " $ "), _c('span', {
    staticClass: "write-to-us"
  }, [_vm._v("./NapiszDoNas")])]), _vm._v(" "), _c('table', [_c('tr', {
    class: {
      blink_me: !_vm.phone, active: _vm.phone
    }
  }, [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "input-field"
  }, [_vm._v("telefon:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input-field",
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    class: {
      blink_me: !_vm.email, active: _vm.email
    }
  }, [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "input-field"
  }, [_vm._v("e-mail:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-field",
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    class: {
      blink_me: !_vm.text, active: _vm.text
    }
  }, [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "input-field"
  }, [_vm._v("text:")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "input-field",
    attrs: {
      "rows": "4",
      "cols": "50",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "send-btn"
  }, [(_vm.canBeSend()) ? _c('button', {
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v("wyślij")]) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorResultMsg) ? _c('div', {
    staticClass: "err-status-bar"
  }, [_c('span', {
    staticClass: "user-prompt"
  }, [_vm._v(">>>")]), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_vm._v(_vm._s(_vm.errorResultMsg))])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.successResultMsg) ? _c('div', {
    staticClass: "succ-status-bar"
  }, [_c('span', {
    staticClass: "user-prompt"
  }, [_vm._v(">>>")]), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_vm._v(_vm._s(_vm.successResultMsg))])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-panel"
  }, [_c('span', {
    staticClass: "block-panel-btn"
  }), _vm._v(" "), _c('span', {
    staticClass: "block-panel-btn"
  }), _vm._v(" "), _c('span', {
    staticClass: "block-panel-btn"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "user-prompt"
  }, [_c('span', [_vm._v(">>>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "user-prompt"
  }, [_c('span', [_vm._v(">>>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "user-prompt"
  }, [_c('span', [_vm._v(">>>")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d9667bd0!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/Terminal.vue
// module id = 175
// module chunks = 0